module.exports = __webpack_public_path__ + "img/logo_headline.97adbfb1.png";